import * as React from 'react';
import Header from './Header';
import Menu from './Menu';
import { removeUserSession, validateToken } from '../components/utils/Common';
import { useNavigate } from 'react-router-dom';
import MenuMobile from './MenuMobile';
import Loading from '../components/Loading';

interface LayoutProps {
  title: string;
  children: React.ReactNode;
  classes?: string;
}

const Layout: React.FC<LayoutProps> = ({title, children, classes }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (!validateToken()) {
            removeUserSession();
            navigate('/connexion');
            return;
        }
        setLoading(false);
    }, []);
 

  return (
    <React.Fragment>
      <header>
        <title>PME Internotaire BD - {title}</title>
        <link rel="icon" type="image/png" href="/images/favicon.png" />
      </header>

      <div className='header-wrapper'>
        <Header onMobileMenuOpen={setIsMobileMenuOpen} />
      </div>

      { loading ? <Loading /> : 
        <main className={`${classes} layout`} >
          <div className='background'>
            <div className='background__left'></div>
            <div className='background__right'></div>
          </div>
          <div className='layout-container'>
            <div className='menu-wrapper'>
              <Menu />
            </div>
            {isMobileMenuOpen ?
              <MenuMobile />
              : children
            }
          </div>
        </main>
      }
    </React.Fragment>
  )
}

export default Layout;
